const countdownEvent = () => {

    const $container = $('.js-countdown');

    if($container.length > 0) {
        let $days = $container.find('.js-countdown-days');
        let $hours = $container.find('.js-countdown-hours');
        let $minutes = $container.find('.js-countdown-minutes');
        // let $seconds = $container.find('.js-countdown-seconds');

        let exp_string = $container.data('expiration');
        let now_time_string = $container.data('now');
        let countDownDate = new Date(exp_string.replace(' ', 'T')).getTime();
        let now_fixed = new Date().getTime();

        let x = setInterval(function() {

            let now_php = new Date(now_time_string.replace(' ', 'T')).getTime();

            let now = new Date().getTime();

            let fix = now_php - now_fixed;

            now = now + fix;

            let distance = countDownDate - now;

            let days = Math.floor(distance / (1000 * 60 * 60 * 24));
            let hours = Math.floor((distance / (1000 * 60 * 60)) % 24);
            let minutes = Math.floor((distance / 1000 / 60) % 60);
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);

            days = days < 10 ? '0' + String(days) : days;
            hours = hours < 10 ? '0' + String(hours) : hours;
            minutes = minutes < 10 ? '0' + String(minutes) : minutes;
            // seconds = seconds < 10 ? '0' + String(seconds) : seconds;

            $days.text(days);
            $hours.text(hours);
            $minutes.text(minutes);
            // $seconds.text(seconds);

            if (distance <= 0) {
                $days.html('00');
                $hours.html('00');
                $minutes.html('00');
                // $seconds.html('00');
                $container.parents('section.event-countdown').css('display', 'none')
                clearInterval(x);
            }
        }, 1000);
    }
};

export default countdownEvent;